import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import {SiteTopology} from "../../domain/cloud-topology";
import {AuthGuardService} from "../auth-guard.service";
import {environment} from "../../../environments/environment";
import {ResourceService} from "../resource.service";
import {map} from "rxjs/operators";
import {batteriesUrl} from "../../domain/constants";

@Injectable({
  providedIn: 'root'
})
export class TopologyService {
  constructor(private http: HttpClient) {}
  getTopology(): Observable<SiteTopology[]>{
    return this.http.get<SiteTopology[]>(ResourceService.buildUrl([environment.topologyUrl + '/sites'])).pipe(map(responseObj => {
      return responseObj['data']['sites'];
    }));
  }

  getBatterySystems(): Observable<string[]> {

    return this.http.get(ResourceService.buildUrl([environment.topologyUrl, batteriesUrl])).pipe(map(res => res['data']));
  }
}
